import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import clsx from 'clsx';
import CalendarDay from '../CalendarDay/CalendarDay';
import styles from './CalendarWeek.scss';

const DAYS_IN_WEEK = 7;

const CalendarWeek = ({
  year,
  month,
  weekIndex,
  firstDayOffset,
}) => {
  const { daysInMonth } = DateTime.local(year, month);

  return (
    <div className="flex flex-justify-center">
      {
        [...new Array(DAYS_IN_WEEK).keys()].map((index) => {
          const dayIndex = index + 1;
          const day = dayIndex + (weekIndex * DAYS_IN_WEEK) - firstDayOffset;
          const isSpacer = (weekIndex === 0 && dayIndex <= firstDayOffset) || day > daysInMonth;

          if (isSpacer) {
            return (
              <div
                key={`${year}-${month}-${day}`}
                className={clsx('text-align-center', styles.emptyDay)}
              />
            );
          }

          return (
            <CalendarDay
              key={`${year}-${month}-${day}`}
              year={year}
              month={month}
              day={day}
            />
          );
        })
      }
    </div>
  );
};

CalendarWeek.propTypes = {
  year: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  weekIndex: PropTypes.number.isRequired,
  firstDayOffset: PropTypes.number.isRequired,
};

export default React.memo(CalendarWeek);
